module.exports = __webpack_public_path__ + "img/Krag_Det_eksotiske_og_fremmede.ab4e38f2.jpg";